import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const AurorasPage = lazy(() => import('../pages/Auroras'))
const AuroraPage = lazy(() => import('../pages/Aurora'))
const AuroraDataPage = lazy(() => import('../pages/AuroraData'))

export default [
  {
    path: '/auroras',
    element: (
      <AuthGuard
        roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER, UserRole.ADMIN, UserRole.USER]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AurorasPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/auroras/:id',
    element: (
      <AuthGuard
        roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER, UserRole.ADMIN, UserRole.USER]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AuroraPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  },
  {
    path: '/auroras/:id/data',
    element: (
      <AuthGuard
        roles={[UserRole.SUPERADMIN, UserRole.MANUFACTURER, UserRole.ADMIN, UserRole.USER]}
      >
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <AuroraDataPage />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
